import aac from "./aac.svg";
import ai from "./ai.svg";
import archive from "./archive.svg";
import arj from "./arj.svg";
import audio from "./audio.svg";
import avi from "./avi.svg";
import css from "./css.svg";
import csv from "./csv.svg";
import dbf from "./dbf.svg";
import doc from "./doc.svg";
import dwg from "./dwg.svg";
import exe from "./exe.svg";
import fla from "./fla.svg";
import flac from "./flac.svg";
import gif from "./gif.svg";
import html from "./html.svg";
import iso from "./iso.svg";
import jpg from "./jpg.svg";
import js from "./js.svg";
import json from "./json.svg";
import mdf from "./mdf.svg";
import mp2 from "./mp2.svg";
import mp3 from "./mp3.svg";
import mp4 from "./mp4.svg";
import mxf from "./mxf.svg";
import nrg from "./nrg.svg";
import pdf from "./pdf.svg";
import png from "./png.svg";
import ppt from "./ppt.svg";
import psd from "./psd.svg";
import rar from "./rar.svg";
import rtf from "./rtf.svg";
import svg from "./svg.svg";
import text from "./text.svg";
import tiff from "./tiff.svg";
import txt from "./txt.svg";
import unknown from "./unknown.svg";
import video from "./video.svg";
import wav from "./wav.svg";
import wma from "./wma.svg";
import xls from "./xls.svg";
import xml from "./xml.svg";

export const Icons = {
  aac,
  ai,
  archive,
  arj,
  audio,
  avi,
  css,
  csv,
  dbf,
  doc,
  gdoc: doc,
  document: doc,
  dwg,
  exe,
  fla,
  flac,
  gif,
  html,
  iso,
  jpeg: jpg,
  jpg,
  js,
  json,
  mdf,
  mp2,
  mpga: mp3,
  mp3,
  mp4,
  mxf,
  nrg,
  pdf,
  png,
  ppt,
  psd,
  rar,
  rtf,
  svg,
  text,
  tiff,
  txt,
  unknown,
  video,
  wav,
  wma,
  xls,
  xlsx: xls,
  xml,
  webm: video,
  gsheet: xls,
  gslides: ppt,
  docx: doc,
};
